import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { TextField, Button } from "@mui/material";
import request from "../services/Request";
import Swal from "sweetalert2";
import { useAuth } from "./items/AuthProvider";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";

const LoginPage = () => {
  const navigate = useNavigate();
  const { setUser, user } = useAuth();
  const { company } = useParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const loginURL = `${process.env.REACT_APP_SERVER_API}/loginClientUser`;

  useEffect(() => {
    console.log("user", user);
    if (user) {
      navigate(`/`);
    }
  }, []);

  const handleLogin = () => {
    //check is email
    console.log("company", company);

    axios
      .post(
        loginURL,
        {
          email: email,
          password: password,
          company: company,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        localStorage.setItem("user", JSON.stringify(res.data.result));
        setUser(res.data.result);
        window.location.reload();
      })
      .catch((err) => {
        Swal.fire({
          text: err.response?.data?.error?.message || "Something went wrong",
          icon: "error",
        });
        // Swal.fire({
        //   text: JSON.stringify(err),
        //   icon: "error",
        // });
      });
  };

  return (
    <div className="flex justify-center items-center h-screen">
      <div className="bg-white shadow-lg rounded-lg p-8 w-full max-w-md">
        <h2 className="text-2xl font-bold mb-4 text-center">Login</h2>
        <div className="mb-4">
          <TextField
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            required
          />
        </div>
        <div className="mb-4">
          <TextField
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            required
          />
        </div>
        <div className="flex justify-end mb-4">
          <Link
            to={`/resetpassword/${company}`}
            className="text-blue-500 hover:underline text-sm"
          >
            Forgot Password?
          </Link>
        </div>
        <div>
          <Button
            variant="contained"
            color="primary"
            onClick={handleLogin}
            fullWidth
          >
            Login
          </Button>
        </div>
        {/* <p className="mt-4">
          Don't have an account? <Link to="/signup">Sign up</Link>
        </p> */}
      </div>
    </div>
  );
};

export default LoginPage;
